import { jsx as _jsx } from "react/jsx-runtime";
import { TextWithHighlight } from '@dixa/lib-shared-habla';
import { createAppUrl } from 'utils/url/createAppUrl';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { ContactsListItem } from '../../../listItem/contactsListItem';
export function ContactsCompany({ company, selected, }) {
    const { params: { q: searchTerm = '' }, } = useAppSearchParams('/contacts/company/:id');
    return (_jsx(ContactsListItem, { primaryLabel: _jsx(TextWithHighlight, { text: company.name, highlight: searchTerm }), avatar: company, linkTo: createAppUrl({
            path: '/contacts/company/:id',
            params: {
                path: { id: company.id },
                search: { q: searchTerm },
            },
        }), selected: selected }));
}
